var map = {
	"./logo/Azad.png": 926,
	"./logo/IRISA.png": 927,
	"./logo/Mapna.png": 928,
	"./logo/Samseir.png": 929,
	"./logo/day-insurance-gary.png": 930,
	"./logo/day-insurance.png": 931,
	"./logo/dey.png": 932,
	"./logo/diginext-gray.png": 933,
	"./logo/diginext.png": 934,
	"./logo/eastcool-gray.png": 935,
	"./logo/eastcool-rgb.png": 936,
	"./logo/esiminar.png": 937,
	"./logo/irisa-gray.png": 938,
	"./logo/irisa.png": 939,
	"./logo/istcoll.png": 940,
	"./logo/khandevane-gray.png": 941,
	"./logo/khandevane-rgb.png": 942,
	"./logo/khandevaneh.png": 943,
	"./logo/pars.png": 944,
	"./logo/pegah.png": 945,
	"./logo/persis-foods-gray.png": 946,
	"./logo/persis-foods-rgb.png": 947,
	"./logo/refah.png": 948,
	"./logo/shahr-financial-group-gray.png": 949,
	"./logo/shahr-financial-group.png": 950,
	"./logo/shahr.png": 951,
	"./logo/sunich-gray.png": 952,
	"./logo/sunich-rgb.png": 953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;